import React from 'react'

export default function ServicesTitle({ title }) {
    return (
        <div className="section-title">
            <h4 id="servicesTitle">{title}</h4>
            <div></div>
        </div>
    )
}
